// assets
import { IconDatabase, IconDroplets, IconFolders, IconPhoto, IconSitemap, IconUpload } from '@tabler/icons-react'

// constant
const icons = { IconFolders, IconPhoto, IconDatabase, IconSitemap, IconDroplets, IconUpload }

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dataManagement = {
  id: 'data-catalog',
  title: 'Data Catalog',
  type: 'group',
  needAdmin: true,
  children: [
    {
      id: 'upload',
      title: 'Upload',
      type: 'item',
      url: '/upload',
      icon: icons.IconUpload,
      breadcrumbs: false
    },
    {
      id: 'storage',
      title: 'Storage',
      type: 'item',
      url: '/storage',
      icon: icons.IconDatabase,
      breadcrumbs: false
    },
    {
      id: 'collections',
      title: 'Collections',
      type: 'item',
      url: '/collections',
      icon: icons.IconFolders,
      breadcrumbs: false
    },
    {
      id: 'items',
      title: 'Items',
      type: 'item',
      url: '/items',
      icon: icons.IconPhoto,
      breadcrumbs: false
    }
  ]
}

export default dataManagement
